import SubscriptionStatus from './SubscriptionStatus';
import SubscriptionEdit from './SubscriptionEdit';

export default {
  name: 'subscription',
  list: SubscriptionStatus,
  edit: SubscriptionEdit,
};